const SDK_VERSION = "10.75.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
